// extracted by mini-css-extract-plugin
export default {"main":"SearchUser_main__8izxy","formGroup":"SearchUser_formGroup__dv88H","searchBox":"SearchUser_searchBox__TFYS-","searchBtn":"SearchUser_searchBtn__PlCfU"};